/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Highlights_Plan_Day_TitleInputs */

const en_us2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Against the last time you did this workout`)
};

const pt_br2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contra a última vez deste treino`)
};

const es_419_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frente a la última vez que hiciste este entrenamiento`)
};

const pt_pt2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Face à última vez deste treino`)
};

const fr_fr2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par rapport à la dernière fois que tu as fait cette séance`)
};

const de_de2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Vergleich zum letzten Mal mit diesem Training`)
};

const it_it2_workout_highlights_plan_day_title = /** @type {(inputs: Workout_Highlights_Plan_Day_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispetto all'ultima volta di questo allenamento`)
};

/**
* | output |
* | --- |
* | "Against the last time you did this workout" |
*
* @param {Workout_Highlights_Plan_Day_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_plan_day_title = /** @type {((inputs?: Workout_Highlights_Plan_Day_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Plan_Day_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_plan_day_title(inputs)
	if (locale === "es-419") return es_419_workout_highlights_plan_day_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_plan_day_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_plan_day_title(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_plan_day_title(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_plan_day_title(inputs)
	return en_us2_workout_highlights_plan_day_title(inputs)
});
export { workout_highlights_plan_day_title as "workout-highlights.plan_day_title" }